import React from 'react';
import { OptionsSC, StateCheckboxSC } from './option-item.styled';
import { ReactComponent as CheckIcon } from '../../../../../assets/img/svg/small-check.svg';

function OptionItem({ children, onClick, checked, value }) {
  return (
    <OptionsSC>
      <StateCheckboxSC onClick={() => onClick && onClick(value, !checked)} checked={checked}>
        {checked && <CheckIcon />}
      </StateCheckboxSC>
      <div>{children}</div>
    </OptionsSC>
  );
}

export default OptionItem;
